import {
    Button,
    Modal,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    ModalBody,
    FormControl,
    FormLabel,
    Input,
    ModalFooter,
    Select, Flex, Text, CircularProgress, Center
} from "@chakra-ui/react";
import {backendURL} from "../../resources/values";
import React, {useRef, useState} from "react";

export default function NewProjectModal({isModalOpen, handleModalOpen, projects, setProjects}) {
    const [formValues, setFormValues] = useState({
        name: "",
        image_url: "",
        description: "",
        region: "north_america",
        location: "",
        usecase: ""
    });

    const initialRef = useRef(null);
    const finalRef = useRef(null);

    const [errorMessage, setErrorMessage] = useState("");
    const [underSubmission, setUnderSubmission] = useState(false);

    const submitProject = () => {
        setUnderSubmission(true);
        const serverURL = `${backendURL}/projects/`;

        // Send a POST request to the server
        fetch(serverURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formValues),
        })
            .then(response => {
                setUnderSubmission(false);
                if (!response.ok) {
                    throw Error("Error occurred while processing the request");
                } else return response;
            })
            .then(response => response.json())
            .then(data => {
                setFormValues({
                    name: "", image_url: "", description: "", location: "", usecase: ""
                });
                setErrorMessage("");
                handleModalOpen();
            })
            .catch((error) => {
                setUnderSubmission(false);
                console.error('Error:', error);
                setErrorMessage("An error occurred while creating the project. Please try again.");
            });
    };


    return (
        <Modal
            initialFocusRef={initialRef}
            finalFocusRef={finalRef}
            isOpen={isModalOpen}
            onClose={handleModalOpen}
            size={"2xl"}
        >
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>Create a Project</ModalHeader>
                <ModalCloseButton/>

                <ModalBody pb={6}>
                    {
                        underSubmission
                        &&
                        <Flex direction={"column"} alignItems={"center"}>
                            <Text fontSize={"2xl"}>Creating the project</Text>
                            <Center height="150px">
                                <CircularProgress isIndeterminate color="blue.500" size="80px"/>
                            </Center>
                        </Flex>

                    }
                    {
                        !underSubmission
                        &&
                        <>
                            <FormControl mt={4}>
                                <FormLabel>Project Name</FormLabel>
                                <Input placeholder='Project Name' value={formValues.name} onChange={(event) => {
                                    setFormValues({...formValues, name: event.target.value})
                                }}/>
                            </FormControl>

                            <FormControl mt={4}>
                                <FormLabel>Image URL</FormLabel>
                                <Input placeholder='Image URL' value={formValues.image_url} onChange={(event) => {
                                    setFormValues({...formValues, image_url: event.target.value})
                                }}/>
                            </FormControl>

                            <FormControl mt={4}>
                                <FormLabel>Project Description</FormLabel>
                                <Input placeholder='Project Description' value={formValues.description}
                                       onChange={(event) => {
                                           setFormValues({...formValues, description: event.target.value})
                                       }}/>

                            </FormControl>

                            <FormControl mt={4}>
                                <FormLabel>Location</FormLabel>
                                <Input placeholder='Project Location' value={formValues.location}
                                       onChange={(event) => {
                                           setFormValues({...formValues, location: event.target.value})
                                       }}/>

                            </FormControl>

                            <FormControl mt={4}>
                                <FormLabel>Use Case</FormLabel>
                                <Input placeholder='Project Use Case' value={formValues.usecase}
                                       onChange={(event) => {
                                           setFormValues({...formValues, usecase: event.target.value})
                                       }}/>

                            </FormControl>

                            <FormControl mt={4}>
                                <FormLabel>Project Region</FormLabel>
                                <Select w={"fit-content"} defaultValue={"north_america"} value={formValues.region}
                                        onChange={(event) => {
                                            setFormValues({...formValues, region: event.target.value})
                                        }}>
                                    <option value={"north_america"}>North America</option>
                                    <option value={"europe"}>Europe</option>
                                    <option value={"asia"}>Asia</option>
                                    <option value={"australia"}>Australia</option>
                                </Select>


                            </FormControl>
                            {errorMessage !== "" && <Text color={"red.500"} mt={4}>{errorMessage}</Text>}
                        </>
                    }


                </ModalBody>

                <ModalFooter>

                    <Flex justifyContent={"space-between"} w={"full"}>
                        <Button onClick={handleModalOpen}>Cancel</Button>

                        {
                            !underSubmission
                            &&
                            <Button colorScheme='teal' mr={3} onClick={() => {
                                submitProject();
                            }}>
                                Create Project
                            </Button>
                        }
                    </Flex>

                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}